import { ExportColumn } from "shared/components/ExcelExportModal";

/**
 * Complete list of exportable columns for helpdesk tickets
 * Includes all fields from the ticket entity, organized by category
 */
export const HELPDESK_EXPORT_COLUMNS: ExportColumn[] = [
  // ========== BASIC INFORMATION ==========
  {
    id: "id",
    label: "Ticket ID",
    category: "basic",
    defaultSelected: true,
  },
  {
    id: "title",
    label: "Titel",
    category: "basic",
    defaultSelected: true,
  },
  {
    id: "label",
    label: "Label",
    category: "basic",
    defaultSelected: true,
  },
  {
    id: "priority",
    label: "Prioriteit",
    category: "basic",
    defaultSelected: true,
  },
  {
    id: "internalStatus",
    label: "Status",
    category: "basic",
    defaultSelected: true,
  },
  {
    id: "building",
    label: "Gebouw",
    category: "basic",
    defaultSelected: true,
  },
  {
    id: "unit",
    label: "Unit",
    category: "basic",
    defaultSelected: true,
  },
  {
    id: "source",
    label: "Bron",
    category: "basic",
    defaultSelected: true,
  },
  {
    id: "reporter",
    label: "Melder",
    category: "basic",
    defaultSelected: true,
  },
  {
    id: "supplier",
    label: "Leverancier",
    category: "basic",
    defaultSelected: true,
  },
  {
    id: "assignedTo",
    label: "Toegewezen aan",
    category: "basic",
    defaultSelected: true,
  },
  {
    id: "createdAt",
    label: "Aangemaakt op",
    category: "basic",
    defaultSelected: true,
  },

  // ========== DETAILED INFORMATION ==========
  {
    id: "description",
    label: "Beschrijving",
    category: "detail",
    defaultSelected: false,
  },
  {
    id: "internalAnalysis",
    label: "Interne analyse",
    category: "detail",
    defaultSelected: false,
  },
  {
    id: "materialsToOrder",
    label: "Te bestellen materialen",
    category: "detail",
    defaultSelected: false,
  },
  {
    id: "materialsToBring",
    label: "Mee te brengen materialen",
    category: "detail",
    defaultSelected: false,
  },
  {
    id: "solutionProposal",
    label: "Oplossingsvoorstel",
    category: "detail",
    defaultSelected: false,
  },
  {
    id: "actionsTaken",
    label: "Ondernomen acties",
    category: "detail",
    defaultSelected: false,
  },
  {
    id: "estimatedCost",
    label: "Geschatte kost",
    category: "detail",
    defaultSelected: false,
  },

  // ========== ADVANCED INFORMATION ==========
  {
    id: "updatedAt",
    label: "Laatst bijgewerkt",
    category: "advanced",
    defaultSelected: false,
  },

  // ========== HUURDER INFORMATIE ==========
  {
    id: "tenantName",
    label: "Huurder naam",
    category: "contact" as const,
    defaultSelected: false,
  },
  {
    id: "tenantEmail",
    label: "Huurder e-mail",
    category: "contact" as const,
    defaultSelected: false,
  },
  {
    id: "tenantPhone",
    label: "Huurder telefoon",
    category: "contact" as const,
    defaultSelected: false,
  },

  // ========== VENNOOTSCHAP INFORMATIE ==========
  {
    id: "billingCompanyName",
    label: "Te factureren vennootschap",
    category: "company" as const,
    defaultSelected: false,
  },
];

/**
 * Column mapping for Excel export
 * Maps column IDs to actual data field paths in the ticket object
 */
export const HELPDESK_EXPORT_COLUMN_MAPPING: Record<string, string> = {
  id: "id",
  title: "titel",
  label: "label",
  priority: "prioriteit",
  internalStatus: "internalStatus",
  building: "building.id",
  unit: "unit.id",
  source: "source",
  reporter: "reporter",
  supplier: "leverancier naam",
  assignedTo: "assignedTo",
  createdAt: "aangemaakt op",
  description: "beschrijving",
  internalAnalysis: "internalAnalysis",
  materialsToOrder: "materialsToOrder",
  materialsToBring: "materialsToBring",
  solutionProposal: "solutionProposal",
  actionsTaken: "actionsTaken",
  estimatedCost: "estimatedCost",
  accountingType: "accountingType",
  updatedAt: "updatedAt",
  completedAt: "completedAt",
  reopenedAt: "reopenedAt",
  odooId: "odooId",
  sharePointFolderUrl: "sharePointFolderUrl",
  smartSuggestions: "smartSuggestions",
};
